import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

import { MIN_WIDTH } from 'utils/constants';

const COLOR_1 = '#032E45';
const COLOR_2 = '#0696A6';

export const ChartContainer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  position: relative;

  .highcharts-series {
    cursor: pointer;
  }

  .stacked-bar-xaxis-hidden {
    display: none;
  }

  .highcharts-series-inactive {
    opacity: 1;
  }

  .stacked-bar-tooltip--item {
    display: flex;
  }

  .stacked-bar-plotband {
    fill: ${colors.black};
    fill-opacity: 0;
    cursor: pointer;
    transform: scaleY(2) translateY(-5px);
  }

  .stacked-bar-plotband.stacked-bar-plotband__hover {
    stroke: ${colors.grey3};
    stroke-width: 1px;
  }

  .stacked-bar-plotband--selected {
    transform: scaleY(2) translateY(-5px);
  }

  .highcharts-container.bar-chart {
    overflow: auto;
  }

  .highcharts-column-series rect.highcharts-point {
    rx: 0;
  }
`;

export const LegendContainer = styled.div<{ isHidden?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;
  margin-right: 24px;
  visibility: ${(props) => (props.isHidden ? 'hidden' : 'visible')};
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
`;

export const LegendColor = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 1px;
  background-color: ${(props) => props.color};
`;

export const LegendName = styled.div`
  font-size: 11px;
  color: ${colors.grey5};
  margin-left: 8px;
  text-transform: uppercase;
`;

export const SelectedBackgroundContainer = styled.div<{ width?: number }>`
  position: relative;
`;

export const SelectedBackground = styled.div`
  position: absolute;
  background: #444444; // #F7F7F7 to be the same as the background
  opacity: 0.05;
  z-index: 1;
`;

export const TooltipContainer = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  margin: 0;
`;

export const TooltipColor = styled.span<{ colorIndex: number }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  background-color: ${(props) => (props.colorIndex === 0 ? COLOR_1 : COLOR_2)};
`;

export const TooltipItem = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TooltipItemName = styled.span`
  font-size: 11px;
  text-transform: capitalize;
`;

export const TooltipItemValue = styled.strong`
  font-size: 13px;
  margin-left: 12px;
`;

export const SecondaryContent = styled.div`
  height: 100%;
  min-width: ${MIN_WIDTH};
  background-color: ${colors.greyBg};
  padding: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${MIN_WIDTH};
  height: auto;
  padding: 24px 32px;
  background-color: ${colors.white};
  margin-bottom: 32px;
`;

export const PieChartsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const PieChartSection = styled.div`
  display: flex;
  width: 550px;
  height: 567px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  background-color: ${colors.white};
  &:first-child {
    margin-right: 32px;
  }
`;
